import classNames from "classnames"
import { MyModal } from "src/core/components"
import { detailFields } from "src/modules/app_sigo/constants/fields"
import styled from "styled-components"

const MyUIBookingSuccess = props => {
  const { data } = props
  const renderContent = () => {
    const content = data?.[detailFields.fNewOrderContent] || ""
    if (content) {
      return <div dangerouslySetInnerHTML={{ __html: content }}></div>
    }
    return <></>
  }
  const renderLinks = () => {
    const links = data?.[detailFields.fNewOrderLinks]
    if (links && links?.length > 0) {
      return (
        <>
          {links.map((v, i) => {
            return (
              <div className="one-link" key={`one-link-${i}`}>
                <i className="flaticon-right-arrow" />
                <a href={v?.Url} target="_blank" rel="noreferrer">
                  {v?.Title}
                </a>
              </div>
            )
          })}
        </>
      )
    }
    return <></>
  }
  const renderRight = () => {
    const image = data?.[detailFields.fAvatarUrl] || ""
    const name = data?.[detailFields.fName]
    const address = data?.[detailFields.fAddress] || ""
    const plate = data?.[detailFields.fPlateNumber]
    const orderBookingDate = data?.[detailFields.fNewOrderBookingDate]
    const total = data?.[detailFields.fTotalPrice]
    const orderNumber = data?.[detailFields.fOrderNumber]
    return (
      <WrapRight className="booking-info">
        {image && <img src={image} alt="" />}
        <div className="name">{name}</div>
        {address && <div className="address">{address}</div>}
        {plate && <div className="plate mb-15px">{plate}</div>}
        {orderBookingDate && (
          <div className="mauden mb-15px">{orderBookingDate}</div>
        )}
        {total && (
          <div className="item border-top">
            Tổng <span className="pull-right">{total}</span>
          </div>
        )}
        {orderNumber && (
          <div className="item border-top">
            Mã xác nhận
            <span className="pull-right">{orderNumber}</span>
          </div>
        )}
      </WrapRight>
    )
  }
  const renderThingsToKnow = () => {
    const _thingsToKnow = data?.[detailFields.fThingsToKnow]
    if (_thingsToKnow && _thingsToKnow?.length > 0) {
      return (
        <WrapBottom>
          <div className="title mb-16px">Những điều cần biết</div>
          <div className="row need-wrap">
            {_thingsToKnow?.map((v, i) => {
              return (
                <div className="need-item col-sm-6 col-md-4" key={i}>
                  <div className="title-item">{v.Title}</div>
                  <div className="description">{v.Description}</div>
                  {v?.Content && (
                    <button
                      className="btn btn-underline-black show-content"
                      onClick={() => {
                        MyModal.showFromComponent(
                          <div
                            dangerouslySetInnerHTML={{
                              __html: v?.Content,
                            }}
                          ></div>,
                          {
                            title: v.Title,
                            modalClassName:
                              "default modal-filter modal-scrollable-inside",
                            onScrollContent: true,
                          }
                        )
                      }}
                    >
                      Hiển thị thêm
                    </button>
                  )}
                </div>
              )
            })}
          </div>
        </WrapBottom>
      )
    }
    return <></>
  }
  return (
    <Wrap className="wrap-booking-success" id="booking-success">
      <div className="top d-flex">
        <div className="left">
          {renderContent()}
          {renderLinks()}
        </div>
        <div className="right">{renderRight()}</div>
      </div>
      {renderThingsToKnow()}
    </Wrap>
  )
}
const Wrap = styled.div`
  margin: 25px 0;
  & .top {
    & .left {
      width: 60%;
      margin-right: 40px;
    }
    & .right {
      width: calc(40% - 40px);
    }
  }
  & .one-link {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    i {
      margin-right: 10px;
      display: flex;
      color: var(--color-text-000);
    }
    a {
      text-decoration: underline;
      color: var(--color-text-000);
      font-weight: 600;
    }
  }
  @media (max-width: 1010px) {
    margin-top: 5px;
    & .top {
      flex-direction: column-reverse;
      & .left {
        margin-top: 25px;
        width: 100%;
        margin-right: 0;
      }
      & .right {
        width: 100%;
      }
    }
  }
`
const WrapRight = styled.div`
  padding: 25px;
  border: 1px solid var(--color-border-dfdfdf);
  border-radius: 20px;
  img {
    object-fit: cover;
    border-radius: 10px;
    max-height: 400px;
    width: 100%;
  }
  & .name {
    color: var(--mauden);
    font-size: 24px;
    font-weight: 700;
    line-height: 34px;
  }
  & .plate {
    font-weight: 600;
  }
  & .item {
    padding: 20px 0;
    color: var(--mauden);
    &:last-child {
      padding-bottom: 0;
    }
  }
  & .border-top {
    border-top: 1px solid var(--color-border-dfdfdf);
  }
`
const WrapBottom = styled.div`
  margin-top: 30px;
  & .title {
    font-weight: 600;
    font-size: 22px;
    color: var(--color-text-222222);
    margin-top: 12px;
    margin-bottom: 16px;
    &.mb-16px {
      margin-bottom: 16px;
    }
  }
  & .need-wrap {
    line-height: 30px;
    & [class*="col-"] {
      margin-bottom: 12px;
    }
    .need-item .title-item {
      color: var(--den);
      font-weight: bold;
    }
    & .btn-underline-black {
      font-weight: 600;
      font-size: 16px;
      margin-top: 20px;
    }
    & .description {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* Số dòng tối đa */
      -webkit-box-orient: vertical;
    }
  }
  @media (min-width: 768px) {
    & .need-wrap {
      margin-left: -24px;
      margin-right: -24px;
      padding-right: 0;
      & [class*="col-"] {
        padding-left: 24px;
        padding-right: 24px;
      }
    }
  }
`
export default MyUIBookingSuccess
